// The control is the input: `input.icheck` is drawn with the square-green sprite by
// app/assets/stylesheets/icheck_sprite.scss, so there is no wrapper element to keep in sync and
// no hover state to track in React -- `:hover` and `:checked` do it.
const CheckBox = ({
  id,
  label,
  readOnly = false,
  checked = false,
  onChange,
}) => {
  const handleChange = (event) => {
    if (typeof onChange === "function") {
      onChange(event.target.checked);
    }
  };

  return (
    <label className="boolean optional" htmlFor={id}>
      <input
        // `disabled`, not `readOnly`: a checkbox ignores readOnly, and the disabled sprite is
        // what the old wrapper's `disabled` class drew.
        disabled={readOnly}
        type="checkbox"
        className="icheck"
        id={id}
        checked={checked}
        onChange={handleChange}
      />
      {label}
    </label>
  );
};

export default CheckBox;
